import './Welcome.css';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


const Welcome = () => {
  const [showText, setShowText] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setShowText(true);
    }, 500); // delay before showing the text (0.5 seconds)

    const timer2 = setTimeout(() => {
      setShowButton(true);
    }, 1000); // delay before showing the button (1 seconds)

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <div className="app">
      {showText && (
        <>
          <div className="fade-in-text">Welcome to the Microsoft Licensing Recommendation App</div>
          <div className="fade-in-text2">Get the best Microsoft 365 plan for your business needs</div>
        </>
      )}
      {showButton && (
        <button className="get-started-btn" onClick={() => navigate('/features')}>
          Get Started
        </button>
      )}
    </div>
  );
};

export default Welcome;
